import React from "react";
import "./WelcomeModal.css";
import { CgProfile } from "react-icons/cg";

const WelcomeModal = ({ user, onClose }) => {
  return (
    <div className="modal-overlay1">
      <div className="modal-card1">
        {/* Close Button */}
        <button className="modal-close1" onClick={onClose}>
          ✕
        </button>

        {/* Text */}
        <h2 className="modal-title1">
          Welcome Back {user.fullName}!
        </h2>

        {/* Avatar */}
        {/* <img
          src={user.avatar || avatarImg}
          alt="User"
          className="modal-avatar1"
        /> */}
        <CgProfile className="modal-avatar1" />


        {/* OK Button */}
        <button className="modal-ok-btn1" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

export default WelcomeModal;
